<template>
	<div>
		<vButtonGroup>
			<vButton
				v-if="status == 0"
				theme="primary"
				@click="showAttach=true"
			>{{$t('global.common.add',{defaultValue:'添加'})}}</vButton>
			<vButton
				v-if="status == 0"
				theme="warning"
				@click="removeItems"
			>{{$t('global.common.delete',{defaultValue:'删除'})}}</vButton>
			<vButton
				v-if="status == 0 && dataList.length>0"
				theme="success"
				@click="retryAttach"
			>{{$t('fbb.inbound.repush_attachment',{defaultValue:'附件重推'})}}</vButton>
		</vButtonGroup>
		<vTableSimple
			class="margin-top-10"
			:columns="columns"
			:data="dataList"
			@on-check-change="handleChecked"
		></vTableSimple>
		<vModal
			v-model="showAttach"
			:title="$t('global.common.import',{defaultValue:'导入数据'})"
			:showFooter="false"
		>
			<vFormItem
				:label="$t('global.common.attachment_type',{defaultValue:'附件类型'})"
				inline
				labelWidth="auto"
				class="margin-bottom-5"
			>
				<vSelect v-model="fileType">
					<vOption value="ShippingLabel"></vOption>
					<vOption value="PackingList"></vOption>
					<vOption value="BOL"></vOption>
					<vOption value="CartonLabel"></vOption>
                    <vOption value="PalletLabel"></vOption>
                    <vOption value="ItemLabel"></vOption>
                    <vOption value="Other"></vOption>
				</vSelect>
			</vFormItem>
			<footer
				class="margin-bottom-10"
			>{{$t('fbb.inbound.support_formats',{defaultValue:'ShippingLabel、PackingList、BOL三种类型支持格式为：PNG、JPG、PDF；Other格式不限'})}}</footer>
			<compUpload v-bind="getFileProps" @on-close="showAttach=false" @on-success="handleAttach" />
		</vModal>
		<vLoading size="large" transfer :loading="loading"></vLoading>
	</div>
</template>

<script>
import { HttpReturnProcessPlanDelAttachments, HttpReturnProcessPlanUploadAttachments, HttpReturnProcessPlanRetryAttach } from '@/service/salesreturns';
export default {
	props: ['data','activeid','formData'],
	components: {
		compUpload: () => import("@components/templates/upload"),
	},
	data() {
		return {
			type: this.$route.params.type,
			id: this.$route.query.id || "",
            status:0,
			showAttach: false,
			fileType: 'Other',
			loading: false,
			dataList: this.data || [],
			checkedData: []
		}
	},
	created() {
		if(this.activeid){
			this.id = this.activeid
		}
	},
	watch: {
		data(val) {
			this.dataList = val || [];
		},
        formData(val){
            this.status = val.status || 0
        }
	},
	computed: {
		getFileProps() {
			return {
				ajaxRequest: HttpReturnProcessPlanUploadAttachments,
				name: "multipartFile",
				data: {
					attachType: this.fileType,
					id: this.id,
				},
				accept: this.fileType === 'Other' ? '' : 'image/*,application/pdf'
			}
		},
		columns() {
			return [
            {
				type: 'selection',
				formName: 'id',
				width: 60
			},
            {
				title: "No.",
				type: 'index'
			},
            {
				title: this.$t('global.common.attachment_type', { defaultValue: '附件类型' }),
				key: "attachType",
			},
            {
				title: this.$t('global.common.attachment_name', { defaultValue: '附件名称' }),
				key: "filename",
                render: ( h ,{ row })=>{
                    return <a class="color-link" href={row.fileurl} target="_blank" download="true">{row.filename}</a>
                }
			},
            {
				title: this.$t('global.common.createdtime', { defaultValue: '创建时间' }),
				key: "createdAt",
			}]
		},
	},
	methods: {
		handleAttach(res) {
			if (this.type === 'add') {
				this.dataList.push(res.data);
			} else {
				this.$emit('on-update')
			}
			this.showAttach = false;
		},
		handleChecked(rows, val) {
			this.checkedData = val;
		},
		removeItems() {
			const checkedData = this.checkedData;
			if (!checkedData.length) {
				this.$VMessage.warning(this.$t('global.common.select_attachment', { defaultValue: '请选择附件' }));
				return
			}
			this.loading = true;
			HttpReturnProcessPlanDelAttachments({
				id: this.id,
				attachmentIds: checkedData.join(',')
			}).then(res => {
				this.loading = false;
				this.$emit('on-update')
			}).catch(err => {
				this.loading = false;
				this.$VMessage.error(err.message);
			})
		},
		//附件重推
		retryAttach() {
			this.loading = true;
			HttpReturnProcessPlanRetryAttach({ id: this.id }).then(res => {
				this.loading = false;
				this.$VMessage.success(res.message);
			}).catch(err => {
				this.$VMessage.error(err.message);
				this.loading = false;
			})
		}
	}
}
</script>
